import * as toastr from "toastr";
import { MilestoneDetails, MilestoneInvoiceSubmissionModel } from "../../Models/MilestoneInvoice/milestoneInvoiceSubmission";
import * as Services from "../../Services";
import { Reference } from "../../Shared/Constants";
import { SubmitProcessReviewInvoiceCtrl } from "./submitProcessReviewInvoice";

export class SubmitMilestoneCtrl extends SubmitProcessReviewInvoiceCtrl<MilestoneInvoiceSubmissionModel, MilestoneDetails> {
  public static $inject = ["$state", "DocumentApiClient", "ProcessReviewInvoiceApiClient"];

  protected processReviewType: string = Reference.Reference.milestoneProcessReviewType;

  constructor(
    $state: angular.ui.IStateService,
    documentApiClient: Services.DocumentApiClient.IDocumentApiClient,
    processReviewInvoiceApiClient: Services.ProcessReviewInvoiceApiClient.IProcessReviewInvoiceApiClient,
  ) {
    super($state, documentApiClient, processReviewInvoiceApiClient);
  }

  protected onSubmitError(): void {
    toastr.error("There was an error submitting the milestone. If the customer already has an " + this.getInvoiceDocument() + " uploaded, please archive it and resubmit.");
  }

  protected onSubmitSuccess(): void {
    toastr.success("Milestone submitted!");
  }

  protected validate(): boolean {
    return this.ptoDateValid();
  }

  protected getInvoiceSubmission(): MilestoneInvoiceSubmissionModel {
    return new MilestoneInvoiceSubmissionModel(this.igsCustomerNumber);
  }

  protected getInvoiceDetails() {
    this.processReviewInvoiceApiClient.getMilestoneDetails(this.igsCustomerNumber).then((milestoneDetails) => {
      this.invoiceDetails = milestoneDetails;
      this.invoiceSubmission.ptoDate = this.invoiceDetails.proposedPtoDate;
    }).catch((error: any) => {
      this.navigateToCustomerPage();
    });
  }

  private getInvoiceDocument() {
    switch (this.invoiceDetails.milestoneCode) {
      case Reference.Reference.CustomerComplete:
        return "M3 Invoice";
      case Reference.Reference.InstallComplete:
        return "M2 Invoice";
      case Reference.Reference.NoticeToProceed:
        return "M1 Invoice";
    }
  }

  private ptoDateValid = (): boolean => {
    return this.invoiceDetails.milestoneCode === Reference.Reference.CustomerComplete ? (this.invoiceSubmission.ptoDate && !!this.invoiceSubmission.ptoLetter.file) : true;
  }
}
